module.exports = __webpack_public_path__ + "img/03.ebee564d.png";